import { useQuery } from '@tanstack/react-query';
import { loadConfig } from '../api/data-qa-api';
import { LoadResult } from '../data-qa-types';

// Fetches + computes the full review dataset for one model config (Postgres
// impressions, Redshift feature mapping, CSV parsing — a substantial backend
// computation). Cached per (cid, configPath) with an effectively infinite
// staleTime: the model's real inputs don't change mid-review-session, so once a
// model has been loaded once, switching back to it is instant instead of
// re-running the full backend computation. A hard page reload naturally clears
// the cache and re-fetches everything.
export const useMmmDataQaLoad = (
  cid: string | undefined,
  configPath: string | undefined
): ReturnType<typeof useQuery<LoadResult>> =>
  useQuery({
    queryKey: ['mmmDataQALoad', cid, configPath],
    queryFn: () => loadConfig(cid!, configPath!),
    enabled: Boolean(cid && configPath),
    staleTime: Infinity
  });
